// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QEA1","label":"styles_label__2V5En"};